module.exports = __webpack_public_path__ + "img/product_orencia_pic.54cf6c39.png";